const RedactedOverlay = () => {
  return (
    <div className="absolute inset-0 z-10 flex items-end justify-center bg-[linear-gradient(180deg,_rgba(255,_255,_255,_0)_0%,_#FFFFFF_100%)]" />
  );
};

export default RedactedOverlay;
